import React, { FC } from 'react'
import { GetAddressListResponse } from '@app/store/api/customer'
import { Icon } from '@iconify/react'
import { FormattedMessage } from 'react-intl'
import S from './AddressList.styles'

interface AddressListProps {
  data: GetAddressListResponse[]
  onClick: (address: GetAddressListResponse) => void
  onNoAddress: () => void
}

const AddressList: FC<AddressListProps> = ({ data, onClick, onNoAddress }) => {
  const handleClick = (address: GetAddressListResponse) => {
    onClick(address)
  }

  return (
    <S.List>
      {data.map(address => (
        <S.Option key={address.id}>
          <S.OptionButton type="button" onClick={() => handleClick(address)}>
            {address.type !== 'Address' ? (
              <S.AddressContainer>
                <span>{address.description.split('-')[0]}</span>
                <S.AddressCount>
                  <span>{address.description.split('-')[1]}</span>
                  <Icon icon="bx:chevron-right" fontSize={20} />
                </S.AddressCount>
              </S.AddressContainer>
            ) : (
              <>
                {address.text} {address.description}
              </>
            )}
          </S.OptionButton>
        </S.Option>
      ))}
      <S.Option>
        <S.OptionButton onClick={onNoAddress}>
          <FormattedMessage id="quiz_address_page.content.questions.lookup_address.manual_address_prompt" />
        </S.OptionButton>
      </S.Option>
    </S.List>
  )
}

export default AddressList
